var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLinearScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "zbhn346bga",
    d: "M20.313 9.896c-1.073 0-1.98.646-2.386 1.562h-3.042c-.406-.916-1.312-1.562-2.385-1.562-1.073 0-1.98.646-2.385 1.562H7.073c-.406-.916-1.313-1.562-2.386-1.562-1.437 0-2.604 1.166-2.604 2.604 0 1.438 1.167 2.604 2.604 2.604 1.073 0 1.98-.646 2.386-1.562h3.042c.406.916 1.312 1.562 2.385 1.562 1.073 0 1.98-.646 2.385-1.562h3.042c.406.916 1.313 1.562 2.386 1.562 1.437 0 2.604-1.166 2.604-2.604 0-1.438-1.167-2.604-2.605-2.604z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -557) translate(0 132) translate(0 400) translate(79 25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5befbbrfeb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zbhn346bga"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#5befbbrfeb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H52.083V52.083H0z",
    transform: "translate(-13.542 -13.542)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinearScale);
export default __webpack_public_path__ + "static/media/ic-linear-scale.9abc394cc0b8cd58686875fda8bcbc1c.svg";
export { ForwardRef as ReactComponent };